export enum PageContentTabNames {
  CAPABILITIES = 'capabilities',
  HISTORY = 'history',
  SYNC = 'sync',
  PRODUCTS = 'products',
  TEAMS = 'teams',
  CONFIGURATION = 'configuration',
}
